'use strict';
// @flow
const angular = require('angular');

import { IUser } from '../../interfaces';

export default class SettingsController {
  $http: ng.IHttpService;
  user: IUser;
  Auth;

  emailErrors = {};
  emailMessage: string;
  emailSubmitted: boolean;
  newEmail: string;

  passwordErrors = {};
  passwordMessage: string;
  passwordSubmitted: boolean;
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;

  profileErrors = {};
  profileMessage: string;
  profileSubmitted: boolean;
  newProfile: IUser;

  status = {
    isEmailOpen: false,
    isPasswordOpen: false,
    isProfileOpen: true
  };

  /*@ngInject*/
  constructor($http, Auth) {
    this.Auth = Auth;
    this.$http = $http;
  }

  $onInit() {
    //Boolean for accordion module
    this.status.isProfileOpen = true;
    this.emailSubmitted = false;
    this.emailMessage = '';

    this.passwordSubmitted = false;
    this.passwordMessage = '';
    this.oldPassword = '';
    this.newPassword = '';
    this.confirmNewPassword = '';

    this.profileSubmitted = false;
    this.profileMessage = '';
    
    this.Auth.getCurrentUser()
    .then(user => {
      this.user = _.cloneDeep(user);
      this.newProfile = _.cloneDeep(user);
      this.newEmail = this.user.email;
      
      this.$http.get('/api/memberships/member')
      .then(res => {
        this.newProfile.membership = (res.data as any);
      });
    });
  }

  reloadEmail() {
    this.emailSubmitted = false;
    this.Auth.getCurrentUser()
    .then(user => {
      this.user = _.cloneDeep(user);
      this.newEmail = this.user.email;
    });
  }

  reloadPassword() {
    this.passwordSubmitted = false;
    this.oldPassword = '';
    this.newPassword = '';
    this.confirmNewPassword = '';

    this.Auth.getCurrentUser()
    .then(user => {
      this.user = _.cloneDeep(user);
    });
  }

  reloadProfile() {
    this.profileSubmitted = false;
    this.Auth.getCurrentUser()
    .then(user => {
      this.user = _.cloneDeep(user);
      this.newProfile = _.cloneDeep(user);
      
      this.$http.get('/api/memberships/member')
      .then(res => {
        this.newProfile.membership = (res.data as any).membership;
      });
    });
  }

  reset() {
    this.emailMessage = '';
    this.passwordMessage = '';
    this.profileMessage = '';
  }

  changeProfile(form) {
    this.reset();
    this.profileErrors = {};
    this.profileSubmitted = true;
    
    if(form.$valid) {
      return this.$http.put('/api/memberships/'+this.newProfile.membership._id, this.newProfile.membership)
      .then((result) => {
        this.profileMessage = 'setting_profile_success';
        this.reloadPassword();
      })
      .catch(err => {
        // Update validity of form fields that match the mongoose errors
        angular.forEach(err.errors, (error, field) => {
          form[field].$setValidity('mongoose', false);
          this.profileErrors[field] = error.message;
        });

      });
    }
  }

  changeEmail(form) {
    this.reset();
    this.emailErrors = {};
    this.emailSubmitted = true;

    if(form.$valid) {
      if (this.user.email !== this.newEmail) {
        this.Auth.changeEmail(this.newEmail)
          .then(() => {
            this.emailMessage = 'setting_email_success';
            this.reloadEmail();
          })
          .catch((err) => {
            if (err.data.name == 'ValidationError' && err.data.errors['email']) {
              if (err.data.errors['email'].kind == 'EXIST') {
                form.email.$setValidity('mongoose', false);
                this.emailErrors = 'email_error_exist';
              }
            } else {
              this.emailErrors = 'email_error_other';
            }
            /* form.email.$setValidity('mongoose', false);
            this.emailErrors = 'email_exist'; */
          });
      }
    }
  }

  changePassword(form) {
    this.reset();
    this.passwordErrors = {};
    this.passwordSubmitted = true;
    
    if(form.$valid) {
      form.confirmNewPassword.$error.match = false;
      form.confirmNewPassword.$invalid = false;
      form.confirmNewPassword.$valid = true;

      if (this.newPassword === this.confirmNewPassword) {
        this.Auth.changePassword(this.oldPassword, this.newPassword)
          .then(() => {
            this.passwordMessage = 'setting_password_success';
            this.reloadPassword();
          })
          .catch((err) => {
            form.password.$setValidity('mongoose', false);
            this.passwordErrors = 'pw_incorrect';
          });
      } else {
        form.confirmNewPassword.$error.match = true;
        form.confirmNewPassword.$invalid = true;
        form.confirmNewPassword.$valid = false;
      }
    }
  }

  changeField(field) {
    field.$setValidity('mongoose', true);
    field.$error.mongoose = false;
  }
  
}



// WEBPACK FOOTER //
// ./client/app/account/settings/settings.controller.ts